import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
import {CustomEase} from 'gsap/CustomEase';
gsap.registerPlugin( ScrollTrigger, CustomEase );
( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;
    },
    finalize: function() {
    },
    animate: function() {
      if ( !window.matchMedia( '(prefers-reduced-motion)' ).matches ) {
        const playLineGraphic = function( lineGraphic ) {
          if ( lineGraphic.dataset.lineDrawPlayed === 'true' ) {
            return;
          }

          lineGraphic.dataset.lineDrawPlayed = 'true';
          $( lineGraphic ).addClass( 'is-line-draw-preparing' ).removeClass( 'js-animated' );
          lineGraphic.getBoundingClientRect();
          window.requestAnimationFrame( function() {
            $( lineGraphic ).removeClass( 'is-line-draw-preparing' );
            window.requestAnimationFrame( function() {
              $( lineGraphic ).addClass( 'js-animated' );
            } );
          } );
        };

        const playVisibleLineGraphics = function() {
          document.querySelectorAll( '.js-line-draw:not(.js-ignore)' ).forEach( function( lineGraphic ) {
            const bounds = lineGraphic.getBoundingClientRect();
            if ( bounds.top < window.innerHeight && bounds.bottom > 0 ) {
              playLineGraphic( lineGraphic );
            }
          } );
        };

        $( `
        .js-fade:not(.js-ignore),
        .js-reveal:not(.js-ignore),
        .js-fade-group,
        .js-line-draw:not(.js-ignore)
        ` ).each( function() {
          if ( $( this ).hasClass( 'js-line-draw' ) ) {
            const siblingLineGraphics = Array.from( this.parentElement.querySelectorAll( ':scope > .js-line-draw:not(.js-ignore)' ) );
            const lineGraphicIndex = siblingLineGraphics.indexOf( this );
            this.style.setProperty( '--line-draw-delay', Math.max( lineGraphicIndex, 0 ) * 1 + 's' );

            $( this ).find( '[data-line-draw-path]' ).each( function() {
              const lineLength = this.getTotalLength();
              // Explicit pixel units are required for reliable SVG dash interpolation in Safari.
              this.style.setProperty( '--line-draw-length', `${lineLength}px` );
            } );
          }

          gsap.registerPlugin( ScrollTrigger );
          const tl = gsap.timeline( {
            scrollTrigger: {
              trigger: this,
              start: 'top 85%',
              scrub: 0.15,
              onRefresh: ( self ) => {
                if ( self.progress > 0 && !$( this ).hasClass( 'js-line-draw' ) ) {
                  $( this ).addClass( 'js-animated' );
                }
              },
              onEnter: ( {progress, direction, isActive} ) => {
                if ( $( this ).hasClass( 'js-line-draw' ) ) {
                  playLineGraphic( this );
                  return;
                }

                if ( $( this ).hasClass( 'js-fade-group' ) ) {
                  // Splide duplicates slides for looping; only stagger original slides.
                  $( this ).find( '> *:not(.splide__slide--clone)' ).each( function( childKey, child ) {
                    const delay = ( childKey + 1 ) / 10;
                    child.style.setProperty( '--fade-group-delay', delay + 's' );
                  } );
                }
                $( this ).addClass( 'js-animated' );
              },
            },
          } );
        } );
        window.setTimeout( playVisibleLineGraphics, 100 );
        $( window ).off( 'pageshow.lineDraw' ).on( 'pageshow.lineDraw', playVisibleLineGraphics );

        $( `
          .js-fade.fade-on-load:not(.js-ignore),
          .js-reveal.fade-on-load:not(.js-ignore),
          .js-fade-group.fade-on-load
          ` ).each( function() {
          gsap.registerPlugin( ScrollTrigger );
          const tl = gsap.timeline( {
            scrollTrigger: {
              trigger: this,
              start: 'top 100%',
              scrub: 0.15,
              onRefresh: ( self ) => {
                if ( self.progress > 0 ) {
                  $( this ).addClass( 'js-animated' );
                }
              },
              onEnter: ( {progress, direction, isActive} ) => {
                if ( $( this ).hasClass( 'js-fade-group' ) ) {
                  // Splide duplicates slides for looping; only stagger original slides.
                  $( this ).find( '> *:not(.splide__slide--clone)' ).each( function( childKey, child ) {
                    const delay = ( childKey + 1 ) / 10;
                    child.style.setProperty( '--fade-group-delay', delay + 's' );
                  } );
                }
                $( this ).addClass( 'js-animated' );
              },
            },
          } );
        } );
      }
    },
    onError: function() {
      document.querySelectorAll( '.js-fade' )?.forEach( ( el ) => {
        el.classList.remove( 'js-fade' );
      } );
      document.querySelectorAll( '.js-line-draw' )?.forEach( ( el ) => {
        el.classList.add( 'js-animated' );
      } );
    },
  };
  app.registerComponent( 'animations', COMPONENT );
} )( app );
